import Menu from './Compartido/Menu.jsx';
import CabeceraAyuda from './Ayuda/CabeceraAyuda.jsx';
import TextosAyuda from './Ayuda/TextosAyuda.jsx';
import Footer from './Compartido/Footer.jsx';

const Ayuda = (props) => {
    return (
        <main>
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.config}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
            />
            <CabeceraAyuda
                ruta={props.ruta}
                textopol={props.textopolitica}
            />
            <TextosAyuda
                config={props.config}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Ayuda;
